import type { MenuAction, MenuMultiAction } from './types';

export const isMenuMultiAction = (
  action: MenuAction,
): action is MenuMultiAction => {
  return (
    Boolean(action) &&
    'subActions' in action &&
    action.subActions.length > 0 &&
    'subActions' in action.subActions[0]!
  );
};
